import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserCertification } from '../model/certification';
import { getUserCertifications } from '../api/certifications';

interface CertificationState {
  currentUserCertifications: UserCertification[] | null
}

const initialState: CertificationState = {
  currentUserCertifications: null
};

const sortAlphabetical = <T extends {[key: string]: any }>(items: T[], ascending: boolean, field: string): T[] => {
  const effectiveField = field === "email" ? "userEmail" : field;
  const copy = items.slice();

  copy.sort((a, b) => {
    let aValue = a[effectiveField]?.toLowerCase?.() ?? ""
    let bValue = b[effectiveField]?.toLowerCase?.() ?? ""
    
    return ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
  });

  return copy
};

const certificationSlice = createSlice({
  name: 'certification',
  initialState,
  reducers: {
    setCurrentUserCertifications: (state, action: PayloadAction<UserCertification[]>) => {
      state.currentUserCertifications = action.payload;
    },
    sortCurrentUserCertifications: (state, action: PayloadAction<{ ascending: boolean, field: string}>) => {
      if (state.currentUserCertifications == null) {
        return
      }

      state.currentUserCertifications = sortAlphabetical(state.currentUserCertifications, action.payload.ascending, action.payload.field);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserCertificationsAsync.fulfilled, (state: CertificationState, action: PayloadAction<UserCertification[]>) => {
        state.currentUserCertifications = action.payload;
      })
      .addCase(getUserCertificationsAsync.rejected, (state: CertificationState, action) => {
        console.error(action.error.message);
      })
  },
});

export const getUserCertificationsAsync = createAsyncThunk('program/getUserCertificationsAsync', async ({ programId, accessToken }: { programId: string; accessToken: string}) => {
    const response = await getUserCertifications(accessToken, programId);
    return response;
  }
);


export const { setCurrentUserCertifications, sortCurrentUserCertifications } = certificationSlice.actions;
export default certificationSlice.reducer;